import React, { Component, ElementType } from 'react';
import { Typo3Context } from '.';
import { insertHtmlEntities } from '../../utils/insertHtmlEntities';
import { Typo3State } from './types';

interface Typo3LabelProps {
  label: string;
  children?: string;
  data?: { [key: string]: string | undefined };
  wrapper?: ElementType;
  // additional props for the optional `wrapper` component
  [additionalProps: string]: any;
}

export default class Typo3Label extends Component<Typo3LabelProps> {
  public renderLabel = ({ translateTypo3 }: Typo3State) => {
    const { label, data, children, wrapper: Wrapper, ...props } = this.props;
    if (Wrapper) {
      return (
        <Wrapper {...props}>
          {insertHtmlEntities(translateTypo3(label, data || null, children))}
        </Wrapper>
      );
    }
    return insertHtmlEntities(translateTypo3(label, data || null, children));
  };

  public render() {
    return <Typo3Context.Consumer>{this.renderLabel}</Typo3Context.Consumer>;
  }
}
